import { register, registerComponent } from '@site/js/utils/react-register'

import CopAgreementDetails from '../dcx/cop/components/CopAgreementDetails'
import CopAssetDetails from '../dcx/cop/components/CopAssetDetails'
import CopAssetTreeIcon from '../dcx/cop/components/CopAssetTreeIcon/CopAssetTreeIcon'
import CopCaseDetailsSection from '../dcx/cop/components/CopCaseDetailsSection'
import CopContacts from '../dcx/cop/components/CopContacts'
import CopCardHomepage from '../dcx/cop/components/CopHomePageCard/CopHomePageCard'
import CopHomePageCount from '../dcx/cop/components/CopHomePageCount/CopHomePageCount'
import CopLogout from '../dcx/cop/components/CopLogout/CopLogout'
import CopNotifications from '../dcx/cop/components/CopNotifications'
import CopPerformanceChart from '../dcx/cop/components/CopPerformanceChart/CopPerformanceChart'
import CopProductCatalog from '../dcx/cop/components/CopProductCatalog'
import CopReportDataIssue from '../dcx/cop/components/CopReportDataIssue'
import CopSiteDetails from '../dcx/cop/components/copSiteDetails'
import CopSubscription from '../dcx/cop/components/copSubscription'
import CopUserAccount from '../dcx/cop/components/CopUserAccount/CopUserAccount'
import CopWcnDocuments from '../dcx/cop/components/CopWcnDocuments'
import { initTokenExpiryWatcher } from '../dcx/cop/components/SilentTokenProvider/sessionExpiryGuard'
import { initSwitchAccountRedirect } from '../dcx/cop/components/SilentTokenProvider/switchAccountTrigger'
import { triggerCopTokenIfSessionPresent } from '../dcx/cop/components/SilentTokenProvider/triggerOnPageLoad'
import UserManagement from '../dcx/cop/components/UserManagement'
import UserManagementRoleExplanation from '../dcx/cop/components/UserManagementRoleExplanation'
import Abbreviation from './Abbreviation'
import AgendaSlider from './AgendaSlider'
import AnchorNavigation from './AnchorNavigation'
import Icon from './Atoms/Icon'
import { Comments } from './Comments'
import ContactHub from './ContactHub'
import { Countdown } from './Countdown'
import GalleryLightbox from './GalleryLightbox'
import ImageWrapper from './ImageWrapper'
import Infobox from './Infobox'
import SearchJobRedirect from './SearchJobRedirect'
import { TagList } from './TagList'
import TeamsNotificationsInPage from './TeamsNotificationsInPage'
import TheWall from './TheWall'
import WorkdayJobs from './WorkdayJobs'
import { initReactInAuthorMode as initAuthorMode } from './react-author-mode'
import { enableMocking, registerReactComponent } from './register-react-component'

export { registerReactComponent }

export function initReactComponents() {
  // Ensure token is stored in localStorage first, then trigger the redirect logic.
  triggerCopTokenIfSessionPresent()
    .then(() => {
      initSwitchAccountRedirect()
      initTokenExpiryWatcher()
    })
    .catch(err => console.error('[CopTokenAuth] page-load trigger failed:', err))
  enableMocking()
    .then(() => {
      registerComponent('ContactHub', ContactHub)
      registerComponent('TeamsNotificationsInPage', TeamsNotificationsInPage)
      registerComponent('Abbreviation', Abbreviation)
      registerComponent('TheWall', TheWall)
      registerComponent('Icon', Icon)
      registerComponent('Infobox', Infobox)
      registerComponent('WorkdayJobs', WorkdayJobs)
      registerComponent('AgendaSlider', AgendaSlider)
      registerComponent('GalleryLightbox', GalleryLightbox)
      registerComponent('TagList', TagList)
      registerComponent('Countdown', Countdown)
      registerComponent('AnchorNavigation', AnchorNavigation)
      registerComponent('ImageWrapper', ImageWrapper)
      registerComponent('Comments', Comments)
      registerComponent('SearchJobRedirect', SearchJobRedirect)
      registerComponent('CopPerformanceChart', CopPerformanceChart)
      registerComponent('CopLogout', CopLogout)
      registerComponent('CopCardHomepage', CopCardHomepage)
      registerComponent('CopHomePageCount', CopHomePageCount)
      registerComponent('CopNotifications', CopNotifications)
      registerComponent('CopUserAccount', CopUserAccount)
      registerComponent('CopDetails', CopAgreementDetails)
      registerComponent('CopAssetDetails', CopAssetDetails)
      registerComponent('CopCaseDetails', CopCaseDetailsSection)
      registerComponent('CopContacts', CopContacts)
      registerComponent('CopProductCatalog', CopProductCatalog)
      registerComponent('CopSiteDetails', CopSiteDetails)
      registerComponent('CopReportDataIssue', CopReportDataIssue)
      registerComponent('CopAssetTreeIcon', CopAssetTreeIcon)
      registerComponent('CopSubscription', CopSubscription)
      registerComponent('UserManagement', UserManagement)
      registerComponent('UserManagementRoleExplanation', UserManagementRoleExplanation)
      registerComponent('CopWcnDocuments', CopWcnDocuments)
    })
    .catch(e => console.error(e))
}

export function initReactInAuthorMode() {
  initAuthorMode(undefined, initReactComponents)
}

const abTestingImageWrapperObserver = new MutationObserver(function () {
  try {
    const imageWrapperElement = document?.getElementsByTagName('image-wrapper')
    if (imageWrapperElement?.length > 0) {
      register(imageWrapperElement, (render, rootElement) => {
        const classes = Array.from(rootElement.children[0]?.classList).join(' ') || ''
        const dataImageSrc = JSON.parse((rootElement.children[0] as HTMLElement)?.dataset.imageSrc)
        const modelJson = {
          ...dataImageSrc,
          pattern: `${dataImageSrc?.pattern.split('?')[0]}?${encodeURIComponent('wid=${width}&hei=${height}&fmt=${format}&fit=crop,1')}` || '',
        }
        const imageSrc = rootElement.getElementsByTagName('img')[0]?.src || ''
        const alt = rootElement.getElementsByTagName('img')[0]?.alt || ''

        render(<ImageWrapper modelJson={JSON.stringify(modelJson)} imageSrc={imageSrc} imageAlt={alt} classes={classes} />)
      })
      abTestingImageWrapperObserver.disconnect()
    }
  } catch (error) {
    abTestingImageWrapperObserver.disconnect()
    console.error('abTestingImageWrapperObserver failed.', error)
  }
})
abTestingImageWrapperObserver.observe(document.body, { childList: true, subtree: true })